import {AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {
  ExcRestService,
  IExcDataDistinct,
  IExcDataFilter,
  IExcDataPaging,
  IExcDataSort,
  IRequestOptions
} from 'exc-rest-v2';
import {ExgDataTableComponent, ExgTableSettingsComponent} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ApplicationService} from '../../services/application.service';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {DataService} from '../../services/data.service';
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styles: []
})
export class MessageListComponent extends ExcTranslation implements OnInit, AfterViewInit {

  /****************************/
  @ViewChild('VCmessageTable', {read: ExgDataTableComponent}) VCmessageTable!: ExgDataTableComponent;
  @ViewChild('VCmessageTableFilterControl', {read: ExgFilterComponent})
  VCmessageTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCmessageTableSortControl', {read: ExgFilterComponent})
  VCmessageTableSortControl!: ExgFilterComponent;
  @ViewChild('VCmessageTableSearchControl', {read: ExgFilterComponent})
  VCmessageTableSearchControl!: ExgFilterComponent;
  @ViewChild(ExgFilterChipsComponent) VCFilterChips!: ExgFilterChipsComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  /****************************/
  Data: any;

  /****************************/
  init = true;
  preFilterDefinition: any[] = [];
  selectedMod: any;
  selectedType: any;
  AIQueue: any =  {
    processing: false
  };
  messageTable = {
    selectKey: 'msgID',
    prefilterMod: 'adm',
    prefilterTyp: 'new',
    newV2Table: false,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    uiFilterEnumGroup: [
      {
        enmName: 'NachrichtKategorie',
        enmField: 'msgNachrichtKategorie_enmIdent',
        enmTable: 'Nachricht'
      },
      {
        enmName: 'NachrichtPrio',
        enmField: 'msg_enmIdent_NachrichtPrio',
        enmTable: 'Nachricht'
      },
      {
        enmName: 'NachrichtTyp',
        enmField: 'msg_enmIdent_NachrichtTyp',
        enmTable: 'Nachricht'
      },
    ],
    uiFilterSearchFields: [
      {table: 'Nachricht', tableField: 'msgAbsender'},
      {table: 'Nachricht', tableField: 'msgBetreff'},
      {table: 'Nachricht', tableField: 'msgText'},
    ],
    uiSortFieldGroup: [
      {fieldGroup: 'Nachricht', fieldTable: 'All', fieldName: 'msgCRU'},
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter((filters: any) => !filterType || (filterType && filterType === filters.filterType))
        .filter((filters: any) =>
          ((filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 &&
              filters.filterType === 2))
        );
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25, pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0},
    isLoading: true,


    ready: () => {
      if (!this.messageTable.data || this.messageTable.data.length === 0) {
        this.messageTable.state = 2;
        if (this.VCmessageTable) {
          this.VCmessageTable.selectedRow = -1;
        }
      } else {
        this.messageTable.state = 0;
        if (this.VCmessageTable) {
          this.VCmessageTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.messageTable.isLoading = false;

      this.VCFilterChips?.workspace.computeMetaInfo(this.appSvc.helperObj.clone(this.messageTable.MetaInfo));
    },
    selectionChanged: (index: number) => {
      this.messageTable.selectedRow = this.messageTable.data[index];
    },
    dblClick: (index: number) => {
      this.messageTable.selectionChanged(index);
      this.VCmessageTable.selectedRow = index;
      this.openMail();
    },
    pageChanged: (page: number) => {
      if (this.messageTable.MetaInfo.dataPaging !== undefined) {
        this.messageTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.messageTable.loadData();
    },
    search: (value: string) => {
      this.messageTable.searchValue = value;
      this.messageTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.messageTable.state = 1;
      SELF.messageTable.isLoading = true;
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl(
            'MessageR_List',
            {
              mod: this.messageTable.prefilterMod,
              typ: this.messageTable.prefilterTyp,
              fts: this.messageTable?.searchValue
            }), 'MessageListState', {
            MetaInfo: {
              dataPaging: this.messageTable.MetaInfo.dataPaging,
              dataSort: this.messageTable.MetaInfo.dataSort,
              dataFilter: this.messageTable.MetaInfo.dataFilter
            }
          })
        .subscribe(
          (response) => {
            if (response.success && response.data) {
              SELF.AIQueue = response.data.AIQueue;
              SELF.messageTable.data = response.data.Messages;
              SELF.messageTable.paging = response.paging.Messages;
            } else {
              SELF.AIQueue.processing = false;
              SELF.messageTable.data = [];
              SELF.messageTable.paging = {
                pagingPage: 0, pagingEndRow: 0, pagingPageSize: 25
                , pagingTotalPages: 0, pagingTotalRows: 0, pagingStartRow: 0
              };
            }
            SELF.messageTable.ready();
          }
        );
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.messageTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('MessageR_List',
            {
              mod: this.messageTable.prefilterMod,
              typ: this.messageTable.prefilterTyp,
              fts: this.messageTable?.searchValue
            }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.messageTable.MetaInfo}
        ).subscribe((ret: any) => {
        // console.log(ret.data);
        this.messageTable.distinctData = ret.data;
      });
    },
    isFiltered: () => {
      return (this.messageTable.MetaInfo.dataFilter && JSON.stringify({}) !== JSON.stringify(this.messageTable.MetaInfo.dataFilter));
    }
  };

  Events = new ExgApplicationEventEmitter();

  constructor(
    private appSvc: ApplicationService,
    private chDecRef: ChangeDetectorRef,
    public excRest: ExcRestService,
    public enumSvc: EnumerationService,
    public excSecurity: ExcSecurityService,
    private dataSvc: DataService,
    private http: HttpClient
  ) {
    super();
  }

  ngOnInit(): void {
    this.registerEvents();
    this.initTableDefinition();
    this.initialize();
    this.initEnumerations();
  }

  ngAfterViewInit(): void {
    if (!this.enumSvc.loading) {
      this.initPreFilter();
    }
  }

  initPreFilter(): void {
    if (this.excSecurity.isFeatured('EISUSR')) {
      this.messageTable.prefilterTyp = 'Claims';
      this.setMailboxAsActive();
    } else {
      this.selectedMod = this.preFilterDefinition[0];
      this.messageTable.prefilterMod = this.selectedMod.value;

      if (this.Data?.inputPreFilterValue) {
        if (this.Data?.inputPreFilterValue === 0) {
          this.messageTable.prefilterTyp = 'new';
        } else if (this.Data?.inputPreFilterValue === 1) {
          this.messageTable.prefilterTyp = 'read';
        } else if (this.Data?.inputPreFilterValue === 5) {
          this.messageTable.prefilterTyp = 'send';
        } else if (this.Data?.inputPreFilterValue === 3) {
          this.messageTable.prefilterTyp = 'all';
        }
      }

      this.selectedType = this.selectedMod.types.find((i: any) => {
        return i.value === String(this.messageTable.prefilterTyp);
      });
      this.VCmessageTableFilterControl.ApplyFilter();
    }
  }

  setMailboxAsActive(): void {
    const pfFilter = {
      value: 'pf',
      caption: 'Postfach',
      types: this.preFilterDefinition[1].types
    };
    this.changePreFilterMod(pfFilter);
  }

  initEnumerations(): void {
    this.preFilterDefinition[1].types = [];
    for (const pf of this.enumSvc.getEnumerationList('Postfach').sort((a, b) => a.enmText.localeCompare(b.enmText))) {
      this.preFilterDefinition[1].types.push({value: pf.enmIdent, caption: pf.enmText});
    }
    this.messageTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.messageTable.uiFilterEnumGroup,
      this.messageTable.uiFilterSearchFields);
    this.messageTable.uiSort = this.appSvc.metaInfo.dataSort(this.messageTable.uiSortFieldGroup);
  }

  initTableDefinition(): void {
    this.messageTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Nachricht', 'msg_enmIdent_NachrichtTyp')
        , value: 'msg_enmIdent_NachrichtTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('NachrichtTyp', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Nachricht', 'msgAbsender')
        , value: 'msgAbsender'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Nachricht', 'msgDatum')
        , value: 'msgCRD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Nachricht', 'msgZeit')
        , value: 'msgCRD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: 'HH:mm:ss'
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Nachricht', 'msgBetreff')
        , value: 'msgBetreff'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Nachricht', 'msgNachrichtKategorie_enmIdent')
        , value: 'msgNachrichtKategorie_enmIdent'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('NachrichtKategorie', value);
        }
      },
    ];
  }

  initialize(): void {
    const SELF = this;
    this.preFilterDefinition = [{
      value: 'mn', get caption(): string {
        return ExcCoreModule.Services().ExcSecurityService.UserName;
      }, types: [{
        value: 'new', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'read', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'done', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'all', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'trash', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'send', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'sdesk', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'sdeskDone', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }, {
        value: 'sdeskTrash', get caption(): string {
          return SELF.getRessource('mn.' + this.value);
        }
      }]
    }, {
      value: 'pf', get caption(): string {
        return SELF.getRessource(this.value + '.caption');
      }, types: []
    }, {
      value: 'adm', get caption(): string {
        return SELF.getRessource(this.value + '.caption');
      }, types: [{
        value: 'lasthalf', get caption(): string {
          return SELF.getRessource('adm.' + this.value);
        }
      }, {
        value: 'lastyear', get caption(): string {
          return SELF.getRessource('adm.' + this.value);
        }
      }, {
        value: 'archive', get caption(): string {
          return SELF.getRessource('adm.' + this.value);
        }
      }, {
        value: 'all', get caption(): string {
          return SELF.getRessource('adm.' + this.value);
        }
      }, {
        value: 'del', get caption(): string {
          return SELF.getRessource('adm.' + this.value);
        }
      }]
    }];
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      this.messageTable.loadData();
    });
    this.enumSvc.repositoryLoaded.subscribe(() => {
      this.initEnumerations();
      this.initTableDefinition();
      this.initPreFilter();
    });
    this.Events.Message.Reader.LinkChanged?.subscribe((evt: ExgEventArgs) => {
      this.dataSvc.Task.Summary.Get();
      this.dataSvc.Case.Summary.Get();
    });
  }

  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    this.messageTable.prefilterMod = event.value;
    this.changePreFilterType(this.selectedMod.types[0]);
  }

  changePreFilterType(event: any): void {
    this.selectedType = event;
    this.messageTable.prefilterTyp = event.value;
    this.VCmessageTableFilterControl.ApplyFilter();
  }

  openMail(): void {
    if (this.VCmessageTable.selectedRow !== -1) {
      this.appSvc.Message.Reader.OpenTab(
        {msgID: this.messageTable.selectedRow?.msgID}, { Events: this.Events }
      ).Open();
    }
  }

  openTableSettings($event: any): void {
    if (this.messageTable.newV2Table) {
      this.VCtableDefinitionSettings.openFilterConfig($event);
    }
  }
  isAIActive(): boolean {
    return this.excSecurity.isFeatured('AIUSE') && this.messageTable.prefilterMod === 'pf'
      && this.getRessource('pf.AIActivated').includes(this.selectedType?.value) && this.messageTable.data?.length > 0;
  }
  startKIAgent(): void {
    if ( this.AIQueue?.processing ) {
      return;
    }
    this.AIQueue.processing = true;
    this.excRest.post(this.excRest.computeUrl('AIQueueC', { kiqtype: 'process-postbox' }),
      {
        kiqPayload: JSON.stringify({ postbox: this.enumSvc.getEnumerationTextA(this.selectedMod.caption, this.selectedType.value)}),
        kiqScopeType: this.selectedMod.caption,
        kiqScopeID: this.selectedType.value,
        kiqVisibility: 'public'
      })
      .subscribe(res => {
        console.log(res);
      });
  }
}
